import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ScriptLoaderService, ScriptModel } from '@uzurv/clara';
import { Observable } from 'rxjs';
import { AppConfiguration, APP_CONFIGURATION } from '../../app/app-configuration';
import { map } from 'rxjs/operators';

@Injectable()
export class GoogleAnalyticsResolver implements Resolve<Observable<ScriptModel>> {
  constructor(private scriptLoaderService: ScriptLoaderService, @Inject(APP_CONFIGURATION) private appConfiguration: AppConfiguration) {}

  resolve() {
    return this.scriptLoaderService.load({
      name: 'Google Analytics',
      src: `https://www.googletagmanager.com/gtag/js?id=${this.appConfiguration.googleAnalyticsMeasurementId}`,
      loaded: false
    }).pipe(
      map(script => {
        this.scriptLoaderService.addScript(`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${this.appConfiguration.googleAnalyticsMeasurementId}');
        `);
        return script;
      })
    )
  }
}
